/**
 * Builds a contact's full display name including middle name/initial.
 * Handles null/undefined gracefully — always returns a trimmed string.
 *
 * Usage:
 *   import { fullName } from '../../lib/contactName'
 *   fullName(contact)           // "John Paul Smith"
 *   fullName(contact, 'last')   // "Smith, John Paul"  (last-first format)
 */
export function fullName(contact, format = 'first') {
  if (!contact) return ''
  const first  = (contact.first_name  || '').trim()
  const middle = (contact.middle_name || '').trim()
  const last   = (contact.last_name   || '').trim()

  const parts = [first, middle, last].filter(Boolean)
  if (!parts.length) return ''

  if (format === 'last' && last) {
    const rest = [first, middle].filter(Boolean).join(' ')
    return rest ? `${last}, ${rest}` : last
  }

  return parts.join(' ')
}

/**
 * Returns initials for avatar display. Includes middle initial if present.
 * e.g. "John Paul Smith" → "JS" (just first + last for avatar brevity)
 */
export function initials(contact) {
  if (!contact) return ''
  const first = (contact.first_name || '').trim()
  const last  = (contact.last_name  || '').trim()
  return `${first[0] || ''}${last[0] || ''}`.toUpperCase()
}
